import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
// import "../css/App.css"
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const Hero = () => {
    return (
        <motion.div id="hero" className="hero" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            <div className="hero-inner">
                <p className="hero-eyebrow">Servants of Our Lady of Evangelization</p>
                <motion.h2 className="hero-text">Why do Catholics believe what they believe?</motion.h2>
                <p className="hero-subtext">A college apostolate for catechesis, apologetics, and the honest case for the Catholic faith.</p>
                <div className="hero-rule" aria-hidden="true" />
            </div>
        </motion.div>
    );
};

const WhatIsSOLE = () => {
    return (
        <section className="section section-light sole-info" id="about">
            <div className="section-inner">
                <h2>What is SOLE?</h2>
                <p>
                    Servants of Our Lady of Evangelization (SOLE) is a Catholic apostolate dedicated to deepening the understanding of God and the Catholic faith among both Catholic and non-Catholic college students. Our mission is to faithfully present the theology and teachings of the Catholic Church so that all may come to recognize and embrace them as truth.
                </p>
                <p>
                    Through lectures, public outreach, and digital resources, SOLE seeks to win souls for Christ by forming disciples through rigorous catechesis, theological and intellectual formation, respectful dialogue, and the confident proclamation of Catholic doctrine.
                </p>
                <p>
                    We host weekly talks, facilitate public Q&A tabling, and offer online platforms like Catholic Defense Hub—all designed to equip individuals to understand, articulate, and share the Catholic faith with clarity and conviction.
                </p>
            </div>
        </section>
    );
};

const History = () => {
    return (
        <motion.section className="section section-dark" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            <div className="section-inner">
                <h2>Our History</h2>
                <p>
                    SOLE originated in 2003 at Texas A&M University as the Aggie Catholic Apologetics Team (AggieCAT), later evolving into Aggie Catholic Apologetics and Theology. Today, SOLE operates as a national apostolate, offering formation resources that empower college students across the country to evangelize with clarity, charity, and conviction.
                </p>
            </div>
        </motion.section>
    );
};

const GetInvolved = () => {
    return (
        <motion.section className="section section-light" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            <div className="section-inner">
                <h2>Get Involved</h2>
                <p>
                    Get involved by joining our mission, supporting us through donations, or launching a SOLE chapter in your community to help spread the Gospel through faithful evangelization.
                </p>
            </div>
        </motion.section>
    );
};

// const WhySOLE = () => {
//     return (
//         <motion.section className="section section-dark" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
//             <h2>Why SOLE?</h2>
//             <p>We synthesize apologetics, catechesis, and evangelization to bring the fullness of the faith to all.</p>
//         </motion.section>
//     );
// };

const QuoteBanner = () => {
    return (
        <motion.section className="quote-banner" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            <blockquote>
                <p>"The Church exists to evangelize." — Paul VI</p>
            </blockquote>
            <p className="quote-motto">Fides quaerens intellectum · Faith seeking understanding</p>
        </motion.section>
    );
};
const CallToAction = () => {
    return (
        <section className="section section-dark subscribe-contact-cta" id="stay-connected">
            <div className="section-inner">
                <h2>Stay Connected</h2>
                <p>Subscribe to our mailing list or reach out to us directly.</p>
                <div className="cta-buttons">
                    <Link to="/subscribe" className="subscribe-button narrow">
                        Subscribe
                    </Link>
                    <Link to="/contact" className="subscribe-button narrow">
                        Contact Us
                    </Link>
                </div>
            </div>
        </section >
    )
}

const Home = () => {
    const [showCandlePopup, setShowCandlePopup] = useState(false);

    useEffect(() => {
        // Only show if not dismissed in this session
        const dismissed = sessionStorage.getItem('candle_popup_dismissed') === '1';
        if (dismissed) return;

        const t = setTimeout(() => setShowCandlePopup(true), 2500); // ~2.5s after load
        return () => clearTimeout(t);
    }, []);

    const closeCandlePopup = () => {
        setShowCandlePopup(false);
        sessionStorage.setItem('candle_popup_dismissed', '1');
    };

    return (
        <div className="App home-page">
            <Navbar />
            <Hero />
            <WhatIsSOLE />
            <History />
            <GetInvolved />
            <CallToAction />
            <QuoteBanner />
            {/* Candle availability popup */}
            {showCandlePopup && (
                <div
                    className="modal-backdrop show"
                    onClick={closeCandlePopup}
                    aria-hidden={!showCandlePopup}
                >
                    <div
                        className="modal-card"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Candle now available"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-head">
                            <h3>Altar Flame is now available</h3>
                            <button onClick={closeCandlePopup} className="modal-close" aria-label="Close">×</button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-thumb">
                                <img
                                    src="candledemo.jpg"
                                    alt="Altar Flame Candle"
                                />
                            </div>
                            <div className="modal-copy">
                                Bring the fragrance of the sanctuary into your home. Order the <strong>Altar Flame</strong> candle today.
                            </div>
                        </div>
                        <div className="actions">
                            <button
                                onClick={closeCandlePopup}
                                className="subscribe-button narrow btn-secondary"
                            >
                                Not now
                            </button>
                            <Link
                                to="/candle"
                                className="subscribe-button narrow"
                                onClick={closeCandlePopup}
                            >
                                Shop the candle
                            </Link>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div >
    );
};

export default Home;